<template>
    <div class="checkbox-invalid">
         <!-- :label="field.label" -->
        <b-form-group
            class="kyc-status-radio overwrite-radio"
           
            :label-for="`id_${field._id}`"
            :class="{
                'required-field': field.isRequired || isRequired,
            }"
        ><label
                :class="{
                    'urdu-label': urduLabel,
                    'urdu-label-justify': urduLabel && field.key == 'fatcaInfo.declaration'
                }"
                >{{ field.label }}</label
            >
        <!-- <label for=""
                >{{ field.label }}<br v-if="field.breakLine"><span v-if="field.urduLabel" class="urdu-label">({{ field.urduLabel }})</span
            ></label> -->
            <div v-if="field.key == 'fatcaInfo.declaration'">
            <b-form-checkbox-group 
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :options="field.options"
                :name="field._id"
                :disabled="loading || isDisabled"
                data-vv-name="FATCA Declaration"
                :class="{
                    'is-invalid': errors.has('FATCA Declaration'),
                }"
                @input="checked"
                @blur="handleBlur"
            ></b-form-checkbox-group>
            </div>
            <div v-else>
                 <b-form-checkbox-group
                v-model="model"
                v-validate="{
                    required: field.isRequired,
                }"
                :options="field.options"
                :name="field._id"
                :disabled="loading || isDisabled"
                :data-vv-name="field.label"
                :class="{
                    'is-invalid': errors.has(field.label),
                }"
                @input="checked"
                @blur="handleBlur"
            ></b-form-checkbox-group>
            </div>
           
        </b-form-group>
    </div>
</template>

<script>
import TextField from './TextField'

export default {
    // End of Component > inject

    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {},
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: TextField, // End of Component > extends

    /*
    |--------------------------------------------------------------------------
    | Component > inject
    |--------------------------------------------------------------------------
    */
    inject: {
        $validator: '$validator',
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        field: {
            type: Object,
            required: true,
        },
        isRequired:{
            type : Boolean,
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            textField: 'title',
            valueField: '_id',
            options: [],
            isDisabled: false,
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        urduLabel(){
            if(this.$store.state.registration.form.languageOption == 'urd'){
                return true
            } else {
                return false
            }
        }
    }, // End of Component > components

    created() {
        if (this.field.key == 'accountInfo.mailNature') {
            this.$store.watch(
                (state) => {
                    return this.$store.state.registration.form.accountInfo
                        .receiveAccountStatement // could also put a Getter here
                },
                (newValue, oldValue) => {
                    //something changed do something
                    // console.log(oldValue)
                    // console.log(newValue)

                    if (newValue == 'Yes') {
                        this.field.isRequired = true
                        this.isDisabled = false
                    } else {
                        this.isDisabled = true
                        this.field.isRequired = false
                    }
                }
            )
        }
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {

        if (this.field.key == 'accountInfo.mailNature') {
            if (
                this.$store.state.registration.form.accountInfo
                    .receiveAccountStatement == 'Yes'
            ) {
                this.field.isRequired = true
                this.isDisabled = false
            } else {
                this.isDisabled = true
                this.field.isRequired = false
            }
        }
        if (this.field.key == 'recieveOtpOption') {
            let isd = this.$store.state.registration.form.contactInfo.isdCode
            // console.log('isd is ', isd)
            if (isd !== '+92') {
                this.isDisabled = true
            }
        }
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        // handleBlur(){
        //   console.log('Blur Hit Check')
        //   this.$root.$emit('updateTempCustomer')
        // },
        checked(event) {
          if (this.field._id == '608aafd68b4820c6c2f65bca' || this.field._id == '61b21a63cd7c60623fae7b5a') {
              const checked = []
              for (let i = 0; i < event.length; i++) {
                  for (let j = 0; j < this.field.options.length; j++) {
                      if (event[i] == this.field.options[j].value) {
                          checked.push(this.field.options[j])
                      }
                  }
              }
              // console.log("checked ", checked)
              var max = checked.reduce((prev, current) =>
                  prev.value > current.value ? prev : current
              )
              // console.log("max obj ", max)
              //console.log(this.field.options[index]._id)
              this.$emit('change', {
                  optionId: max._id,
                  parentID: this.field._id,
                  optionTitle: max.text,
                  parentTitle: this.field.label,
              })
          }

          /**
           * Updating Temp Customer
           */
          this.$root.$emit('updateTempCustomer')
        },
    }, // End of Component > mounted
}
</script>
